import { render } from "./App.vue?vue&type=template&id=034fcd51&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=034fcd51&scoped=true&lang=css"

import exportComponent from "../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034fcd51"]])

export default __exports__